// import React from "react";
// import { Box, Typography, IconButton } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

// const PreviewFaq = ({ data, onEdit, onDelete }) => {
//   const handleCardClick = (index, e) => {
//     if (e) {
//       e.stopPropagation();
//       e.preventDefault();
//     }
//     if (onEdit) {
//       onEdit("faq", index);
//     }
//   };

//   const handleDelete = (index, e) => {
//     if (e) {
//       e.stopPropagation();
//       e.preventDefault();
//     }
//     if (window.confirm("Are you sure you want to delete this FAQ?")) {
//       if (onDelete) {
//         onDelete("faq", index);
//       }
//     }
//   };

//   return (
//     <Box onClick={(e) => e.stopPropagation()}>
//       <Typography
//         variant="caption"
//         color="text.secondary"
//         fontWeight={600}
//         display="block"
//         mb={2}
//       >
//         {data.sectionTitle}
//       </Typography>

//       <Box display="flex" gap={2} flexWrap="wrap">
//         {data.items
//           .filter((i) => i.question)
//           .map((item, i) => (
//             <Box
//               key={i}
//               onClick={(e) => handleCardClick(i, e)}
//               sx={{
//                 flex: "0 0 250px",
//                 background: "rgba(255,255,255,0.05)",
//                 border: "1px solid rgba(255,255,255,0.1)",
//                 borderRadius: "10px",
//                 p: 2,
//                 cursor: "pointer",
//                 transition: "all 0.2s",
//                 position: "relative",
//                 "&:hover": {
//                   background: "rgba(255,255,255,0.08)",
//                   borderColor: "#3b82f6",
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
//                 },
//               }}
//             >
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: 8,
//                   right: 8,
//                   display: "flex",
//                   gap: 0.5,
//                 }}
//               >
//                 <IconButton
//                   size="small"
//                   onClick={(e) => handleDelete(i, e)}
//                   sx={{
//                     width: 24,
//                     height: 24,
//                     background: "rgba(244,67,54,0.1)",
//                     color: "#f44336",
//                     "&:hover": {
//                       background: "rgba(244,67,54,0.2)",
//                     },
//                   }}
//                 >
//                   <DeleteOutlineIcon sx={{ fontSize: 14 }} />
//                 </IconButton>
//                 <IconButton
//                   size="small"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handleCardClick(i, e);
//                   }}
//                   sx={{
//                     width: 24,
//                     height: 24,
//                     background: "rgba(59,130,246,0.1)",
//                     color: "#3b82f6",
//                     "&:hover": {
//                       background: "rgba(59,130,246,0.2)",
//                     },
//                   }}
//                 >
//                   <EditIcon sx={{ fontSize: 14 }} />
//                 </IconButton>
//               </Box>

//               <Box display="flex" flexDirection="column" gap={1}>
//                 {/* Question Icon */}
//                 <Box
//                   sx={{
//                     width: 32,
//                     height: 32,
//                     borderRadius: "50%",
//                     background: "rgba(59,130,246,0.1)",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   <Typography fontSize={16}>❓</Typography>
//                 </Box>

//                 {/* Question */}
//                 <Typography variant="subtitle2" fontWeight={600}>
//                   {item.question}
//                 </Typography>

//                 {/* Answer Preview */}
//                 {item.answer && (
//                   <Typography
//                     variant="caption"
//                     color="text.secondary"
//                     sx={{
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       display: "-webkit-box",
//                       WebkitLineClamp: 2,
//                       WebkitBoxOrient: "vertical",
//                     }}
//                   >
//                     {item.answer}
//                   </Typography>
//                 )}
//               </Box>
//             </Box>
//           ))}

//         {!data.items.some((i) => i.question) && (
//           <Typography variant="caption" color="text.secondary">
//             No FAQs added yet
//           </Typography>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default PreviewFaq;


import React from "react";
import { Box, Typography } from "@mui/material";
import SummaryCard from "../shared/SummaryCard";

const PreviewFaq = ({ data, onEdit, onDelete }) => (
  <Box onClick={(e) => e.stopPropagation()}>
    {data.sectionTitle && (
      <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={2}>
        {data.sectionTitle}
      </Typography>
    )}

    <Box display="flex" gap={2} flexWrap="wrap">
      {data.items.filter((i) => i.question).length === 0 ? (
        <Typography variant="caption" color="text.secondary">No FAQs added yet</Typography>
      ) : (
        data.items.filter((i) => i.question).map((item, i) => (
          <SummaryCard
            key={i}
            width={250}
            onClick={() => onEdit?.("faq", i)}
            onDelete={() => onDelete?.("faq", i)}
          >
            <Box display="flex" flexDirection="column" gap={1}>
              <Box sx={{ width: 32, height: 32, borderRadius: "50%", background: "rgba(59,130,246,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Typography fontSize={16}>❓</Typography>
              </Box>
              <Typography variant="subtitle2" fontWeight={600}>{item.question}</Typography>
              {item.answer && (
                <Typography variant="caption" color="text.secondary" sx={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                  {item.answer}
                </Typography>
              )}
            </Box>
          </SummaryCard>
        ))
      )}
    </Box>
  </Box>
);

export default PreviewFaq;